import script from "./BlogArticleView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogArticleView.vue?vue&type=script&setup=true&lang=js"

import "./BlogArticleView.vue?vue&type=style&index=0&id=c01a9024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c01a9024"]])

export default __exports__